// getClassBasedOnTime: Función para retornar la Clase CSS condicional basada en la diferencia de tiempo (en minutos)
export const getClassBasedOnTime = (timeDifference, setTimeDifference) => {
    if (timeDifference <= 4) {
        return "message-priority-low"; // Clase para mensajes de baja prioridad (menor o igual a 5 min). 
    } else if (timeDifference <= 9) {
        return "message-priority-medium"; // Clase para mensajes de prioridad media (menor o igual a 10 min). 
    } else {
        return "message-priority-high"; // Clase para mensajes de alta prioridad (mayor a 2 min). 
    }
};
